<template>
  <div id="gestor-form">
    <div id="content">
      <template v-if="!responseError && !responseOk">
        <Header
          @add="add()"
          :page="'gestor'"
          :title_one="'team'"
          :title_two="'add_gestor'"
          :action_one="'save'"
          :action_two="'cancel'"
        ></Header>
        <!-- <h2 class="title">{{$t('add_gestor')}}</h2> -->
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <div class="box">
              <div class="radio-group">
                <v-radio-group v-model="type" row class="options">
                  <v-radio
                    class="radio"
                    :label="$t('params.new_gestor')"
                    value="1"
                  ></v-radio>
                  <v-radio
                    class="radio"
                    :label="$t('params.existing_gestor')"
                    value="2"
                  ></v-radio>
                </v-radio-group>
              </div>

              <div v-if="type == 1" style="overflow: hidden;">
                <h6>{{ $t("descriptions.representative") }}</h6>

                <div class="item">
                  <label
                    >{{ $t("params.name") }} <span class="obligatory">*</span>
                  </label>
                  <input
                    v-bind:class="error.name ? 'error' : ''"
                    type="text"
                    v-model="gestor.name"
                    :placeholder="$t('params.name')"
                    autocomplete="nope"
                    class="upper"
                    name="mic-input"
                  />
                </div>

                <div class="item">
                  <label
                    >{{ $t("params.email") }}
                    <span class="obligatory">*</span>
                    <span class="obligatory" v-if="error.duplicated">
                      {{ $t("errors.duplicated_email") }}</span
                    >
                    <span v-if="error.invalit_email" class="obligatory">
                      {{ $t("errors.email") }}</span
                    >
                  </label>
                  <input
                    v-bind:class="error.email ? 'error' : ''"
                    type="email"
                    v-model="gestor.email"
                    :placeholder="$t('params.email')"
                    autocomplete="nope"
                    name="mic-input"
                  />
                </div>

                <div class="item">
                  <label
                    >{{ $t("params.language") }}
                    <span class="obligatory">*</span>
                  </label>
                  <select
                    v-bind:class="error.language ? 'error' : ''"
                    v-model="gestor.language"
                    autocomplete="nope"
                    name="mic-input"
                  >
                    <option
                      v-for="language in languages"
                      v-bind:value="language.id"
                      v-bind:key="language.id"
                    >
                      {{ language.name }}
                    </option>
                  </select>
                </div>

                <div class="item">
                  <!-- <label>{{$t('password')}} <span class="obligatory">*</span> </label>
                                    <input v-bind:class="error.password ? 'error' : ''" type="password" v-model="gestor.password" :placeholder="$t('password')" autocomplete="new-password" name="mic-input" > -->
                </div>
              </div>
              <div v-if="type == 2">
                <div class="item">
                  <template v-if="Object.keys(gestors_list).length > 0">
                    <select v-model="selected_gestor">
                      <option disabled selected value="">{{
                        $t("descriptions.choose_representative")
                      }}</option>
                      <option
                        v-for="gestor in gestors_list"
                        v-bind:value="gestor.id"
                        v-bind:key="gestor.id"
                      >
                        {{ gestor.name }}
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    <!-- <select disabled v-else>
                                            <option disabled selected value="">{{$t('descriptions.no_representative')}}</option>
                                        </select> -->
                    <h6>{{ $t("descriptions.no_representative") }}</h6>
                  </template>
                </div>
              </div>
            </div>
            <ErrorPopup
              @close="closePopup()"
              @input="closePopup()"
              :dialog="dialog"
            ></ErrorPopup>
          </v-layout>
        </v-container>
      </template>

      <template v-else>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <div class="box">
              <div v-if="responseError" message error class="message error">
                {{ $t("errors.api") }}
              </div>

              <div v-if="responseOk" class="success">
                {{ $t("login.email_send") }}
              </div>
            </div>
          </v-layout>
        </v-container>
      </template>
    </div>
  </div>
</template>
<script>
/* global isEmpty, validateEmail */
import Header from '@/components/layout/Header'
import ErrorPopup from '@/components/ui/ErrorPopup.vue'

export default {
  name: 'GestorForm',
  components: {
    Header,
    ErrorPopup
  },
  data () {
    return {
      user: {},
      type: '1',
      dialog: false,
      gestor: {
        name: '',
        password: '',
        email: '',
        language: ''
      },
      error: {
        name: false,
        password: false,
        email: false,
        language: false,
        duplicated: false,
        invalit_email: false
      },
      languages: [
        { id: '1', name: 'Català' },
        { id: '2', name: 'Castellano' },
        { id: '3', name: 'English' }
      ],
      gestors_list: {},
      selected_gestor: '',
      responseError: false,
      responseOk: false
    }
  },
  created () {
    // get user
    this.user = this.$store.getters['user/getUser']
    // check if user is admin
    if (!this.user.admin) {
      this.$router.push({
        name: 'team',
        params: { id: this.$route.params.id }
      })
    }
    // get team information
    var self = this
    this.$store
      .dispatch('club/loadClubEvent', {
        club_id: this.user.club_id,
        event_id: this.user.event_id
      })
      .then(function () {
        var data = self.$store.getters['club/getClub']
        var team = data.teams[self.$route.params.id]
        // check if team has an agent
        if (team && Object.keys(team.gestor).length > 0) {
          self.$router.push({
            name: 'team',
            params: { id: self.$route.params.id }
          })
        }
        // get list from gestors
        for (var i in data.teams) {
          // check if gestor isn't empty
          if (Object.keys(data.teams[i].gestor).length > 0) {
            // save gestor to list
            self.gestors_list[data.teams[i].gestor.id] = data.teams[i].gestor
          }
        }
      })
    this.$store
      .dispatch('team/loadTeam', { team_id: this.$route.params.team_id })
      .then(function () {})
  },
  methods: {
    validate () {
      var validate = true
      // check if type is new gestor
      if (+this.type === 1) {
        // validate name
        if (isEmpty(this.gestor.name)) {
          this.error.name = true
          validate = false
        } else {
          this.error.name = false
        }

        // validate email
        if (isEmpty(this.gestor.email)) {
          this.error.email = true
          validate = false
        } else {
          // validate email
          if (validateEmail(this.gestor.email)) {
            this.error.email = false
            this.error.invalit_email = false
          } else {
            validate = false
            this.error.email = true
            this.error.invalit_email = true
          }
        }

        // validate password
        // if(isEmpty(this.gestor.password)){
        //     this.error.password = true;
        //     validate = false;
        // } else {
        //     this.error.password = false;
        // }

        // validate language
        if (isEmpty(this.gestor.language)) {
          this.error.language = true
          validate = false
        } else {
          this.error.language = false
        }
      }
      return validate
    },
    add () {
      var self = this
      // validate for new gestor
      if (parseInt(this.type) === 1) {
        if (this.validate()) {
          // validate if username is not used
          this.$store
            .dispatch('team/gestorValidateIfExists', {
              username: this.gestor.email
            })
            .then(function () {
              // gestor exists
              //   if (self.$store.getters["team/getGestorExists"]) {
              //     self.error.email = true;
              //     self.error.duplicated = true;
              //     // gestor doesn't exists
              //   } else {
              // encrypt password
              // self.gestor.password = sha256(self.gestor.password);
              self.$store
                .dispatch('team/addDisabledGestor', {
                  team_id: self.$route.params.team_id,
                  gestor: self.gestor
                })
                .then(function (response) {
                  response.status
                    ? (self.responseOk = true)
                    : (self.responseError = true)
                  // self.$router.push({'name' : 'team', 'params' : {'id' : self.$route.params.team_id}});
                })
              //   }
            })
        } else {
          this.dialog = true
        }
      }
      // validate existing gestor
      if (parseInt(this.type) === 2) {
        // add existing gestor
        self.$store
          .dispatch('team/addGestor', {
            team_id: self.$route.params.team_id,
            gestor: { selected_gestor: self.selected_gestor }
          })
          .then(function () {
            self.$router.push({
              name: 'team',
              params: { id: self.$route.params.team_id }
            })
          })
      }
    },
    closePopup () {
      this.dialog = false
    }
  },
  watch: {
    type: function () {
      // selected new gestor
      if (+this.type === 1) {
        this.selected_gestor = ''
      }
      // selected existing gestor
      if (+this.type === 2) {
        this.gestor.name = ''
        this.gestor.password = ''
        this.gestor.email = ''
        this.gestor.language = ''
      }
    }
  }
}
</script>
<style lang="scss">
#gestor-form {
  .box {
    width: 100%;
    margin: 0 auto;
    width: 80%;
    height: 80%;
    overflow: auto;
    text-align: center;

    .message.error {
      color: $warning-color;
    }

    .radio-group {
      width: 100%;

      .options {
        .radio {
          height: 100%;
          text-align: center;
        }
      }
    }

    .item {
      width: calc(50% - 20px);
      margin: 10px 10px;
      display: inline-block;

      label {
        font-size: 14px;
        padding: 0;
        margin-bottom: 5px;
        display: block;
      }

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 20px;
      }

      .error {
        border-color: $alert-color;
        &::placeholder {
          color: $alert-color;
          opacity: 0.5;
        }
      }

      input,
      select {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    button {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: $main-color;
      color: $secondary-color;

      &:hover {
        background: $secondary-color;
        color: $dark-color;
      }
    }

    .upper {
      text-transform: uppercase;
      &::placeholder {
        text-transform: none;
      }
    }

    .success {
      border: 2px solid #087908;
      border-radius: 5px;
      background-color: #a0f8b6;
      color: #000;
      padding: 10px;
      font-size: 16px;
      text-align: center;
    }

    .message.error {
      background-color: #f73f2061;
      margin: 10px 0;
      border: 2px solid #e61515;
      border-radius: 5px;
      padding: 10px;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
  }
}

@include media("<=desktop") {
  .container {
    padding: 0;
  }

  #gestor-form {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;
      .item {
        width: 100%;
        padding: 0;
        margin: 0;
        display: block;
      }
      .radio-group {
        width: 100%;

        .v-input__control {
          width: 100%;
        }

        .radio {
          height: 40px;
          width: 50%;
          float: left;
          margin: 0;
        }
      }
    }
  }
}
</style>
